module.exports = __webpack_public_path__ + "static/media/footer-bg.8f94b7f6.svg";